<div *ngIf="options().length" class="assistance-launcher" data-feedback-ignore="true" data-ai-assistant-ignore="true">
  <div *ngIf="menuOpen()" id="assistance-launcher-menu" class="assistance-launcher-menu" role="menu">
    <button *ngFor="let option of options(); trackBy: trackById" type="button" role="menuitem"
      class="assistance-launcher-option" [ngClass]="'assistance-launcher-option-' + option.id" (click)="choose(option)">
      <span class="assistance-launcher-option-icon"><i [ngClass]="option.icon" aria-hidden="true"></i></span>
      <span>{{ option.label | translate }}</span>
    </button>
  </div>

  <button type="button" class="assistance-launcher-button" [class.assistance-launcher-button-open]="menuOpen()"
    (click)="toggle()" [attr.aria-haspopup]="options().length > 1 ? 'menu' : null"
    [attr.aria-expanded]="options().length > 1 ? menuOpen() : null" aria-controls="assistance-launcher-menu"
    [attr.aria-label]="(options().length > 1 ? 'assistanceLauncher.label' : options()[0].label) | translate"
    [pTooltip]="menuOpen() ? '' : ((options().length > 1 ? 'assistanceLauncher.label' : options()[0].label) | translate)"
    tooltipPosition="left" [showDelay]="400">
    <!-- SVG, not an icon-font glyph: font glyphs are not centred in their box, so the cross looked off-centre. -->
    <svg *ngIf="menuOpen(); else closedIcon" class="assistance-launcher-close" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" stroke-width="2.25" stroke-linecap="round" aria-hidden="true">
      <path d="M6 6l12 12M18 6L6 18" />
    </svg>
    <ng-template #closedIcon>
      <i class="pi" [ngClass]="options().length > 1 ? 'pi-question' : options()[0].icon" aria-hidden="true"></i>
    </ng-template>
  </button>
</div>

<app-keyboard-shortcuts-dialog [visible]="shortcutsOpen()" (visibleChange)="shortcutsOpen.set($event)"></app-keyboard-shortcuts-dialog>
